export default "gmap-map-type-hybrid=Hybrid\ngmap-map-type-roadmap=Roadmap\ngmap-sync-map-move=Sync map moove\n"